import { __decorate, __param, __metadata } from 'tslib';
import { InjectionToken, Inject, Injectable, EventEmitter, Output, Input, Component, Optional, ElementRef, NgZone, Renderer2, Injector, ViewChild, ViewContainerRef, ComponentFactoryResolver, ChangeDetectorRef, Directive, ɵɵdefineInjectable, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, Subject, zip, EMPTY } from 'rxjs';
import { filter, map, take, switchMap, takeUntil, startWith, mergeMap, first } from 'rxjs/operators';
import { NavigationEnd, NavigationError, Router, ActivatedRoute, RouterOutlet, ChildrenOutletContexts } from '@angular/router';

// ================================
// Launch parameters REQUEST
// ================================
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'rxjs';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/router';

function AssetLauncherComponent_dle_integration_launcher_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dle-integration-launcher", 2);
    ɵngcc0.ɵɵlistener("loaded", function AssetLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_loaded_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.loaded.next()); })("initialized", function AssetLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_initialized_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.initialized.next()); })("ready", function AssetLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_ready_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.ready.next()); })("closed", function AssetLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_closed_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.closed.next()); })("message", function AssetLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_message_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.message.next($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("newWindow", ctx_r0.launchInNewWindow)("launchId", ctx_r0.launchId)("launchUrl", ctx_r0.launchUrl)("launchParams", ctx_r0.launchParams)("routeParams", ctx_r0.routeParams)("iFrameClass", ctx_r0.iFrameClass)("styles", ctx_r0.styles)("iFrameScrollingAttr", ctx_r0.iFrameScrollingAttr)("iFrameResizerOptions", ctx_r0.iFrameResizerOptions)("iFrameId", ctx_r0.iFrameId)("iFrameTitle", ctx_r0.iFrameTitle)("toolCommand$", ctx_r0.toolCommand$)("elementsRootConfig", ctx_r0.labsConfig);
} }
function ToolLauncherComponent_dle_integration_launcher_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dle-integration-launcher", 2);
    ɵngcc0.ɵɵlistener("loaded", function ToolLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_loaded_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.loaded.next()); })("initialized", function ToolLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_initialized_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.initialized.next()); })("ready", function ToolLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_ready_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.ready.next()); })("closed", function ToolLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_closed_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.closed.next()); })("message", function ToolLauncherComponent_dle_integration_launcher_1_Template_dle_integration_launcher_message_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.message.next($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("newWindow", ctx_r0.launchInNewWindow)("launchId", ctx_r0.launchId)("launchUrl", ctx_r0.launchUrl)("launchParams", ctx_r0.launchParams)("routeParams", ctx_r0.routeParams)("iFrameClass", ctx_r0.iFrameClass)("styles", ctx_r0.styles)("iFrameScrollingAttr", ctx_r0.iFrameScrollingAttr)("iFrameResizerOptions", ctx_r0.iFrameResizerOptions)("iFrameId", ctx_r0.iFrameId)("iFrameTitle", ctx_r0.iFrameTitle)("toolCommand$", ctx_r0.toolCommand$)("elementsRootConfig", ctx_r0.labsConfig);
} }
const _c0 = ["launchForm"];
function LauncherComponent_named_outlet_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "named-outlet", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r0.outletName);
} }
function LauncherComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 5);
} if (rf & 2) {
    const param_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("name", param_r3.k)("value", param_r3.v);
} }
function isBasicLaunchResponse(v) {
    if (typeof v !== 'object') {
        return false;
    }
    const debugInfoIsValid = v.debugInfo === undefined || (typeof v.debugInfo.baseString === 'string' && typeof v.debugInfo.signature === 'string');
    return debugInfoIsValid
        && typeof v.launchUrl === 'string'
        && isLaunchParams(v.launchParams);
}
function isContentSelectionLaunchResponse(v) {
    if (typeof v !== 'object') {
        return false;
    }
    const debugInfoIsValid = v.debugInfo === undefined || (typeof v.debugInfo.baseString === 'string' && typeof v.debugInfo.signature === 'string');
    return debugInfoIsValid
        && typeof v.launchId === 'string'
        && typeof v.launchUrl === 'string'
        && isLaunchParams(v.launchParams);
}
function isLaunchParams(v) {
    if (typeof v !== 'object') {
        console.error(`Expected LaunchParams, got ${typeof v}`);
        return false;
    }
    for (const p in v) {
        if (typeof p !== 'string' || (typeof v[p] !== 'string')) {
            console.error(`Invalid field for LaunchParams: ${p} === ${v[p]}`);
            return false;
        }
    }
    return true;
}

class LarsRequestError extends Error {
    constructor(message, response) {
        super(message);
        this.response = response;
    }
}

class ContentItemSelectionResponseMonitor {
    constructor(url, handlers) {
        this._heartbeatIntervalInSeconds = 5;
        this._ws = new WebSocket(url);
        this._ws.onmessage = (event) => {
            try {
                const message = JSON.parse(event.data);
                if (message.status === 'ready') {
                    handlers.onSelection(message);
                    this.destroy();
                }
                else if (message.status === 'errored') {
                    handlers.onError('error_cisr');
                    this.destroy();
                }
            }
            catch (err) {
                console.error('failed to handle CISR message from LARS:', event.data);
            }
        };
        this._ws.onclose = (event) => {
            // nothing to do here
        };
        this._ws.onerror = (event) => {
            // try to reconnect before sending an error?
            console.error('websocket had an error!', event);
            handlers.onError('error_ws', event);
        };
        this._startHeartbeat();
    }
    destroy() {
        this._stopHeartBeat();
        this._ws.close();
    }
    _startHeartbeat() {
        this._stopHeartBeat();
        this._heartBeatTimer = window.setInterval(() => this._ws.send('ping'), this._heartbeatIntervalInSeconds * 1000);
    }
    _stopHeartBeat() {
        if (this._heartBeatTimer !== undefined) {
            window.clearInterval(this._heartBeatTimer);
            this._heartBeatTimer = undefined;
        }
    }
}

const LAUNCHER_CONFIG = new InjectionToken('dle-integration-ngx.config');
// use Chrome policy as default across browsers
// https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-permissions-in-cross-origin-iframes
const defaultFeaturePolicy = {
    'microphone': '\'none\'',
    'camera': '\'none\'',
    'encrypted-media': '\'none\'',
    'geolocation': '\'none\'',
    'midi': '\'none\''
};
function policyToString(policy) {
    const resultingPolicy = Object.assign(Object.assign({}, defaultFeaturePolicy), policy);
    return Object.keys(resultingPolicy).map((featureName) => {
        return `${featureName} ${resultingPolicy[featureName]};`;
    }).join(' ');
}

const larsHostNames = {
    dev: 'lars-dev.integration.nonprod.mheducation.com',
    qastg: 'lars-qastg.integration.nonprod.mheducation.com',
    qalv: 'lars-qalv.integration.nonprod.mheducation.com',
    demo: 'lars-demo.integration.nonprod.mheducation.com',
    pqa: 'lars-pqa.integration.nonprod.mheducation.com',
    prod: 'lars.integration.prod.mheducation.com',
};
function larsHostnameFromConfig(config) {
    if (config.larsHostname !== undefined) {
        return config.larsHostname;
    }
    else if (config.sdlcEnvironment !== undefined) {
        if (larsHostNames[config.sdlcEnvironment] === undefined) {
            throw new Error(`IntegrationLauncherModule config is invalid: config.sdlcEnvironment=${config.sdlcEnvironment} is an unknown SDLC`);
        }
        return larsHostNames[config.sdlcEnvironment];
    }
    else {
        throw new Error('IntegrationLauncherModule config is invalid: must define either sdlcEnvironment or larsHostname');
    }
}

var LarsClient_1;
let LarsClient = LarsClient_1 = class LarsClient {
    constructor(http, config$) {
        this.http = http;
        this.config$ = config$;
        // really what we care about from config$ is the hostname
        this.hostname$ = this.config$.pipe(filter((config) => !!config.larsHostname || !!config.sdlcEnvironment), map((config) => larsHostnameFromConfig(config)));
    }
    static buildHeaders(token) {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            })
        };
    }
    assetBasicLaunch(xid, payload, token) {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/v1/assets/${xid}/basic-launch`;
            return this.http.post(url, payload, LarsClient_1.buildHeaders(token));
        }), map(response => {
            if (isBasicLaunchResponse(response)) {
                return response;
            }
            const message = `Unexpected response while fetching basic launch params for asset ${xid}`;
            throw new LarsRequestError(message, response);
        }));
    }
    assetCisrLaunch(xid, payload, token) {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/v1/assets/${xid}/content-item-selection-launch`;
            return this.http.post(url, payload, LarsClient_1.buildHeaders(token));
        }), map(response => {
            if (isContentSelectionLaunchResponse(response)) {
                return response;
            }
            const message = `Unexpected response while fetching CISR params for asset ${xid}`;
            throw new LarsRequestError(message, response);
        }));
    }
    subscriptionBasicLaunch(xid, payload, token) {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/v1/subscriptions/${xid}/basic-launch`;
            return this.http.post(url, payload, LarsClient_1.buildHeaders(token));
        }), map(response => {
            if (isBasicLaunchResponse(response)) {
                return response;
            }
            const message = `Unexpected response while fetching basic launch params for subscription ${xid}`;
            throw new LarsRequestError(message, response);
        }));
    }
    subscriptionCisrLaunch(xid, payload, token) {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/v1/subscriptions/${xid}/content-item-selection-launch`;
            return this.http.post(url, payload, LarsClient_1.buildHeaders(token));
        }), map(response => {
            if (isContentSelectionLaunchResponse(response)) {
                return response;
            }
            const message = `Unexpected response while fetching CIS params for subscription ${xid}`;
            throw new LarsRequestError(message, response);
        }));
    }
    listenToCisrLaunch(launchId, handlers) {
        return this.hostname$.pipe(take(1), map((hostname) => {
            const url = `wss://${hostname}/v1/launches/${launchId}/ws/content-item-selection`;
            return new ContentItemSelectionResponseMonitor(url, handlers);
        }));
    }
};
LarsClient.ɵfac = function LarsClient_Factory(t) { return new (t || LarsClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(LAUNCHER_CONFIG)); };
LarsClient.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LarsClient, factory: function (t) { return LarsClient.ɵfac(t); } });
LarsClient.ctorParameters = () => [
    { type: HttpClient },
    { type: Observable, decorators: [{ type: Inject, args: [LAUNCHER_CONFIG,] }] }
];
LarsClient = LarsClient_1 = __decorate([ __param(1, Inject(LAUNCHER_CONFIG)),
    __metadata("design:paramtypes", [HttpClient,
        Observable])
], LarsClient);

var LauncherService_1;
let LauncherService = LauncherService_1 = class LauncherService {
    constructor(lars) {
        this.lars = lars;
    }
    static determineContextId(options) {
        const { flowOptions = {}, context = {} } = options;
        if (context.context_id) {
            return context.context_id;
        }
        if (context.section_xid) {
            return context.section_xid;
        }
        if (context.org_xid) {
            return context.org_xid;
        }
        if (flowOptions.owner_entity_xid) {
            return flowOptions.owner_entity_xid;
        }
    }
    static buildAdditionalParameters(options) {
        const { flowSelection = {}, flowOptions = {}, context = {} } = options;
        const display_mode = flowSelection.display_mode || 'default';
        const multiple_boolString = flowOptions.multiple_selections ? flowOptions.multiple_selections.toString() : 'false';
        const header_boolString = flowOptions.show_header ? flowOptions.show_header.toString() : 'false';
        const footer_boolString = flowOptions.show_footer ? flowOptions.show_footer.toString() : 'false';
        const allow_arrayString = flowOptions.allow_actions ? flowOptions.allow_actions.join(',') : '';
        const authorizationPolicies_arrayString = flowOptions.authorization_policies ? flowOptions.authorization_policies.join(',') : '';
        return Object.assign({ 
            // lti stuff
            launch_presentation_document_target: 'iframe', tool_consumer_instance_guid: options.platformInstanceGuid, 
            // flow selection
            custom_action: options.action, custom_custom_action: flowSelection.custom_action, custom_display_mode: display_mode, custom_role: flowSelection.role, 
            // flow options
            custom_attempt_id: flowOptions.attempt_id, custom_multiple_selections: multiple_boolString, custom_show_header: header_boolString, custom_show_footer: footer_boolString, custom_allow_actions: allow_arrayString, custom_lineitems_url: flowOptions.lineItemsUrl, custom_scores_url: flowOptions.scoresUrl, custom_list_display_mode: flowOptions.list_display_mode, custom_authorization_policies: authorizationPolicies_arrayString, 
            // context
            custom_org_xid: context.org_xid, custom_section_xid: context.section_xid, custom_learner_xid: context.learner_xid, custom_assignment_xid: context.assignment_xid, custom_course_xid: context.course_xid, custom_assignable_resource_xid: context.assignable_resource_xid, 
            // app options
            custom_timezone: options.time_zone, launch_presentation_locale: options.locale }, options.customParameters);
    }
    fetchAssetLaunchDetails(assetXid, options) {
        const { context = {}, flowOptions = {} } = options;
        if (options.action === 'launch') {
            const basicLaunchParams = {
                additionalParameters: LauncherService_1.buildAdditionalParameters(options),
                assignmentId: context.assignment_xid,
                contextId: LauncherService_1.determineContextId(options),
                withLabsConfig: options.labsNativeLaunch
            };
            return this.lars.assetBasicLaunch(assetXid, basicLaunchParams, options.user_jwt);
        }
        const contentItemLaunchParams = {
            additionalParameters: LauncherService_1.buildAdditionalParameters(options),
            contextId: LauncherService_1.determineContextId(options),
            overrides: {
                ownerEntityXid: flowOptions.owner_entity_xid,
            },
            withLabsConfig: options.labsNativeLaunch
        };
        return this.lars.assetCisrLaunch(assetXid, contentItemLaunchParams, options.user_jwt);
    }
    fetchToolLaunchDetails(subscriptionXid, options) {
        const { flowOptions = {} } = options;
        if (options.action === 'launch') {
            const basicLaunchParams = {
                additionalParameters: LauncherService_1.buildAdditionalParameters(options),
                contextId: LauncherService_1.determineContextId(options),
                withLabsConfig: options.labsNativeLaunch
            };
            return this.lars.subscriptionBasicLaunch(subscriptionXid, basicLaunchParams, options.user_jwt);
        }
        const contentItemLaunchParams = {
            additionalParameters: LauncherService_1.buildAdditionalParameters(options),
            contextId: LauncherService_1.determineContextId(options),
            overrides: {
                ownerEntityXid: flowOptions.owner_entity_xid,
            },
            withLabsConfig: options.labsNativeLaunch
        };
        return this.lars.subscriptionCisrLaunch(subscriptionXid, contentItemLaunchParams, options.user_jwt);
    }
};
LauncherService.ɵfac = function LauncherService_Factory(t) { return new (t || LauncherService)(ɵngcc0.ɵɵinject(LarsClient)); };
LauncherService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LauncherService, factory: function (t) { return LauncherService.ɵfac(t); } });
LauncherService.ctorParameters = () => [
    { type: LarsClient }
];
LauncherService = LauncherService_1 = __decorate([ __metadata("design:paramtypes", [LarsClient])
], LauncherService);

class LauncherError extends Error {
}

let AssetLauncherComponent = class AssetLauncherComponent {
    constructor(launcher) {
        this.launcher = launcher;
        this.loaded = new EventEmitter();
        this.initialized = new EventEmitter();
        this.ready = new EventEmitter();
        this.message = new EventEmitter();
        this.closed = new EventEmitter();
        this.launchRequested = new EventEmitter();
        this.lazyLoad = false;
        this.readyToLaunch = new Subject();
        this._unsubscribe$ = new Subject();
    }
    ngOnChanges() {
        if (!this.assetXid) {
            throw new LauncherError('assetXid @Input() missing on dle-integration-asset-launcher');
        }
        if (!this.options) {
            throw new LauncherError('options @Input() missing on dle-integration-asset-launcher');
        }
        this.clearLaunch();
        this.readyToLaunch
            .pipe(take(1), takeUntil(this._unsubscribe$))
            .subscribe(() => {
            this.launch();
        });
        if (!this.lazyLoad) {
            this.readyToLaunch.next();
        }
    }
    ngOnDestroy() {
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }
    clearLaunch() {
        this.launchParams = undefined;
        this.launchUrl = undefined;
        this.launchId = undefined;
    }
    launch() {
        const { assetXid, options } = this;
        if (assetXid === undefined || options === undefined) {
            return;
        }
        if (this.routeParams && this.routeParams.disableLti) {
            // perform a routed tool launch (deprecated)
            this.launchUrl = null;
            this.launchParams = {};
            this.launchRequested.emit();
        }
        else if (options.labsNativeLaunch) {
            // perform a native launch
            this.launcher.fetchAssetLaunchDetails(assetXid, options).subscribe((details) => {
                this.launchId = details.launchId;
                this.labsConfig = details.labsConfigParameters;
                this.launchUrl = null;
                this.launchParams = {};
                this.launchRequested.emit();
            });
        }
        else {
            // perform a standard LTI launch
            this.launcher.fetchAssetLaunchDetails(assetXid, options).subscribe((details) => {
                this.launchId = details.launchId;
                this.labsConfig = undefined;
                this.launchUrl = details.launchUrl;
                this.launchParams = details.launchParams;
                this.launchRequested.emit(details);
            });
        }
    }
};
AssetLauncherComponent.ɵfac = function AssetLauncherComponent_Factory(t) { return new (t || AssetLauncherComponent)(ɵngcc0.ɵɵdirectiveInject(LauncherService)); };
AssetLauncherComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AssetLauncherComponent, selectors: [["dle-integration-asset-launcher"]], inputs: { lazyLoad: "lazyLoad", assetXid: "assetXid", options: "options", launchInNewWindow: "launchInNewWindow", iFrameClass: "iFrameClass", styles: "styles", iFrameScrollingAttr: "iFrameScrollingAttr", iFrameResizerOptions: "iFrameResizerOptions", iFrameId: "iFrameId", iFrameTitle: "iFrameTitle", toolCommand$: "toolCommand$", routeParams: "routeParams" }, outputs: { loaded: "loaded", initialized: "initialized", ready: "ready", message: "message", closed: "closed", launchRequested: "launchRequested" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "lazyLoad", "load"], [3, "newWindow", "launchId", "launchUrl", "launchParams", "routeParams", "iFrameClass", "styles", "iFrameScrollingAttr", "iFrameResizerOptions", "iFrameId", "iFrameTitle", "toolCommand$", "elementsRootConfig", "loaded", "initialized", "ready", "closed", "message", 4, "ngIf"], [3, "newWindow", "launchId", "launchUrl", "launchParams", "routeParams", "iFrameClass", "styles", "iFrameScrollingAttr", "iFrameResizerOptions", "iFrameId", "iFrameTitle", "toolCommand$", "elementsRootConfig", "loaded", "initialized", "ready", "closed", "message"]], template: function AssetLauncherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("load", function AssetLauncherComponent_Template_div_load_0_listener() { return ctx.readyToLaunch.next(); });
        ɵngcc0.ɵɵtemplate(1, AssetLauncherComponent_dle_integration_launcher_1_Template, 1, 13, "dle-integration-launcher", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("lazyLoad", ctx.lazyLoad);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.launchUrl !== undefined);
    } }, dependencies: function () { return [ɵngcc3.NgIf, LauncherComponent, LazyLoadDirective]; }, encapsulation: 2 });
AssetLauncherComponent.ctorParameters = () => [
    { type: LauncherService }
];
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "loaded", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "initialized", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "ready", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "message", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "closed", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "launchRequested", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "assetXid", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "launchInNewWindow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "iFrameClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "styles", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "iFrameScrollingAttr", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "iFrameResizerOptions", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "iFrameId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "iFrameTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "toolCommand$", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "lazyLoad", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AssetLauncherComponent.prototype, "routeParams", void 0);
AssetLauncherComponent = __decorate([ __metadata("design:paramtypes", [LauncherService])
], AssetLauncherComponent);

let ToolLauncherComponent = class ToolLauncherComponent {
    constructor(launcher) {
        this.launcher = launcher;
        this.loaded = new EventEmitter();
        this.initialized = new EventEmitter();
        this.ready = new EventEmitter();
        this.message = new EventEmitter();
        this.closed = new EventEmitter();
        this.launchRequested = new EventEmitter();
        this.lazyLoad = false;
        this.readyToLaunch = new Subject();
        this._unsubscribe$ = new Subject();
    }
    /**
     * Re-launch when the asset id changes from the initial
     */
    ngOnChanges() {
        if (!this.toolXid) {
            throw new LauncherError('toolXid @Input() missing on dle-integration-tool-launcher');
        }
        if (!this.options) {
            throw new LauncherError('options @Input() missing on dle-integration-tool-launcher');
        }
        this.clearLaunch();
        this.readyToLaunch
            .pipe(take(1), takeUntil(this._unsubscribe$))
            .subscribe(() => {
            this.launch();
        });
        if (!this.lazyLoad) {
            this.readyToLaunch.next();
        }
    }
    ngOnDestroy() {
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }
    clearLaunch() {
        this.launchParams = undefined;
        this.launchUrl = undefined;
        this.launchId = undefined;
    }
    launch() {
        const { toolXid, options } = this;
        if (toolXid === undefined || options === undefined) {
            return;
        }
        if (this.routeParams && this.routeParams.disableLti) {
            // perform a routed tool launch (deprecated)
            this.launchUrl = null;
            this.launchParams = {};
            this.launchRequested.emit();
        }
        else if (options.labsNativeLaunch) {
            // perform a native launch
            this.launcher.fetchToolLaunchDetails(toolXid, options).subscribe((details) => {
                this.launchId = details.launchId;
                this.labsConfig = details.labsConfigParameters;
                this.launchUrl = null;
                this.launchParams = {};
                this.launchRequested.emit();
            });
        }
        else {
            // perform a standard LTI launch
            this.launcher.fetchToolLaunchDetails(toolXid, options).subscribe((details) => {
                this.launchId = details.launchId;
                this.labsConfig = undefined;
                this.launchUrl = details.launchUrl;
                this.launchParams = details.launchParams;
                this.launchRequested.emit(details);
            });
        }
    }
};
ToolLauncherComponent.ɵfac = function ToolLauncherComponent_Factory(t) { return new (t || ToolLauncherComponent)(ɵngcc0.ɵɵdirectiveInject(LauncherService)); };
ToolLauncherComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToolLauncherComponent, selectors: [["dle-integration-tool-launcher"]], inputs: { lazyLoad: "lazyLoad", toolXid: "toolXid", options: "options", launchInNewWindow: "launchInNewWindow", iFrameClass: "iFrameClass", styles: "styles", iFrameScrollingAttr: "iFrameScrollingAttr", iFrameResizerOptions: "iFrameResizerOptions", iFrameId: "iFrameId", iFrameTitle: "iFrameTitle", toolCommand$: "toolCommand$", routeParams: "routeParams" }, outputs: { loaded: "loaded", initialized: "initialized", ready: "ready", message: "message", closed: "closed", launchRequested: "launchRequested" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "lazyLoad", "load"], [3, "newWindow", "launchId", "launchUrl", "launchParams", "routeParams", "iFrameClass", "styles", "iFrameScrollingAttr", "iFrameResizerOptions", "iFrameId", "iFrameTitle", "toolCommand$", "elementsRootConfig", "loaded", "initialized", "ready", "closed", "message", 4, "ngIf"], [3, "newWindow", "launchId", "launchUrl", "launchParams", "routeParams", "iFrameClass", "styles", "iFrameScrollingAttr", "iFrameResizerOptions", "iFrameId", "iFrameTitle", "toolCommand$", "elementsRootConfig", "loaded", "initialized", "ready", "closed", "message"]], template: function ToolLauncherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("load", function ToolLauncherComponent_Template_div_load_0_listener() { return ctx.readyToLaunch.next(); });
        ɵngcc0.ɵɵtemplate(1, ToolLauncherComponent_dle_integration_launcher_1_Template, 1, 13, "dle-integration-launcher", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("lazyLoad", ctx.lazyLoad);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.launchUrl !== undefined);
    } }, dependencies: function () { return [ɵngcc3.NgIf, LauncherComponent, LazyLoadDirective]; }, encapsulation: 2 });
ToolLauncherComponent.ctorParameters = () => [
    { type: LauncherService }
];
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "loaded", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "initialized", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "ready", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "message", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "closed", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "launchRequested", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "toolXid", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "launchInNewWindow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "iFrameClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "styles", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "iFrameScrollingAttr", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "iFrameResizerOptions", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "iFrameId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "iFrameTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "toolCommand$", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "lazyLoad", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ToolLauncherComponent.prototype, "routeParams", void 0);
ToolLauncherComponent = __decorate([ __metadata("design:paramtypes", [LauncherService])
], ToolLauncherComponent);

function hasIframeResizerInstalled(w) {
    return w.hasOwnProperty('iFrameResize');
}
function hasIframeResizer(el) {
    return el.hasOwnProperty('iFrameResizer');
}
function hasIntersectionObserver(w) {
    return w.hasOwnProperty('IntersectionObserver');
}

const REGISTRY_ROUTE_PATH_VALUE = 'module-registry';
let ModuleRouterService = class ModuleRouterService {
    constructor(router) {
        this.router = router;
        this._navigationRequest$ = new Subject();
        if (!router) {
            return;
        }
        const routingOpportunitie$ = this.router.events.pipe(filter((event) => (event instanceof NavigationEnd || event instanceof NavigationError)), startWith(undefined));
        // This is a routing queue implementation to prevent
        // routing requests from squashing each other. We need
        // to make our routing requests only after the last one
        // completes so they don't get cancelled.
        zip(this._navigationRequest$, routingOpportunitie$)
            .subscribe({
            next: ([navigationArgs, navivationCompleteEvent]) => {
                this.router.navigate(...navigationArgs);
            }
        });
    }
    _findRouteInRegistry(moduleId) {
        if (!moduleId) {
            return;
        }
        const registryRootRoute = this.router.config.find((route) => {
            return route.path === REGISTRY_ROUTE_PATH_VALUE;
        });
        if (!registryRootRoute) {
            throw new Error(`Routed launch could not find the module registry node with path=${REGISTRY_ROUTE_PATH_VALUE}`);
        }
        if (!registryRootRoute.children || !registryRootRoute.children.length) {
            throw new Error(`Routed launch failed because the registry node with path=${REGISTRY_ROUTE_PATH_VALUE} has no children`);
        }
        return registryRootRoute.children.find((route) => route.path === moduleId);
    }
    _ensureRouteExists({ moduleId, activatedRoute, outlet }) {
        let routes;
        // locate the Route[] where the module should be inserted
        if (activatedRoute.routeConfig) {
            if (activatedRoute.routeConfig.loadChildren) {
                throw new Error(`Routed launch cannot happen inside an activatedRoute that has loadChildren property set`);
            }
            activatedRoute.routeConfig.children = activatedRoute.routeConfig.children || [];
            routes = activatedRoute.routeConfig.children;
        }
        else if (activatedRoute.routeConfig === null) {
            // We assume that this activedRoute is at the root level of the routing tree.
            routes = this.router.config;
        }
        else {
            throw new Error(`Routed launch cannot determine where to insert module ${moduleId} into routing tree!`);
        }
        // look to see if we have already added this route
        const existingSecondaryRoute = routes.find((route) => {
            return route.path === moduleId && route.outlet === outlet;
        });
        if (existingSecondaryRoute) {
            return existingSecondaryRoute;
        }
        else {
            // We need to add a new route based on an existing one.
            const existingRoute = this._findRouteInRegistry(moduleId);
            if (!existingRoute) {
                throw new Error(`Routed launch could not locate module in registry corresponding to toolInstanceId=${moduleId}`);
            }
            const newRoute = Object.assign(Object.assign({}, existingRoute), { outlet });
            // upadate the this.router.config routes
            routes.unshift(newRoute);
            this.router.resetConfig(this.router.config);
            return newRoute;
        }
    }
    // called from a <feature-stack> component to facilitate a routed launch
    routedLaunch({ moduleId, activatedRoute, outlet, navigationExtras }) {
        if (!this.router) {
            throw new Error('Routed launch has no provider for Router! RouterModule is likely missing.');
        }
        // move the module into place
        this._ensureRouteExists({ moduleId, activatedRoute, outlet });
        // routing command to turn this module "on"
        const route = { outlets: {} };
        route.outlets[outlet] = [moduleId];
        const commands = [route];
        const extras = Object.assign(Object.assign({}, navigationExtras), { queryParamsHandling: 'preserve', relativeTo: activatedRoute });
        this._navigationRequest$.next([commands, extras]);
    }
};
ModuleRouterService.ɵfac = function ModuleRouterService_Factory(t) { return new (t || ModuleRouterService)(ɵngcc0.ɵɵinject(ɵngcc4.Router, 8)); };
ModuleRouterService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModuleRouterService, factory: function (t) { return ModuleRouterService.ɵfac(t); } });
ModuleRouterService.ctorParameters = () => [
    { type: Router, decorators: [{ type: Optional }] }
];
ModuleRouterService = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [Router])
], ModuleRouterService);

/**
 * A service that can dynamically load components based
 * on a provided elementsRegistry.
 */
let ElementLoaderService = class ElementLoaderService {
    constructor(config$) {
        this.config$ = config$;
    }
    find(id) {
        return this.config$.pipe(map(config => {
            if (config.elementsRegistry) {
                return config.elementsRegistry.find((entry) => entry.id === id);
            }
            else {
                return;
            }
        }));
    }
    /**
     * Fetches an Angular element based on id.
     */
    loadElement(id, injector) {
        return this.find(id).pipe(mergeMap(entry => {
            if (entry) {
                return entry.loadElement(injector);
            }
            else {
                throw new Error('Component not found!');
            }
        }));
    }
};
ElementLoaderService.ɵfac = function ElementLoaderService_Factory(t) { return new (t || ElementLoaderService)(ɵngcc0.ɵɵinject(LAUNCHER_CONFIG)); };
ElementLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ElementLoaderService, factory: function (t) { return ElementLoaderService.ɵfac(t); } });
ElementLoaderService.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [LAUNCHER_CONFIG,] }] }
];
ElementLoaderService = __decorate([ __param(0, Inject(LAUNCHER_CONFIG)),
    __metadata("design:paramtypes", [Observable])
], ElementLoaderService);

let LauncherComponent = class LauncherComponent {
    constructor(elementRef, zone, renderer, document, larsClient, moduleRouterService, elementLoaderService, route, injector) {
        this.elementRef = elementRef;
        this.zone = zone;
        this.renderer = renderer;
        this.document = document;
        this.larsClient = larsClient;
        this.moduleRouterService = moduleRouterService;
        this.elementLoaderService = elementLoaderService;
        this.route = route;
        this.injector = injector;
        this.loaded = new EventEmitter();
        this.initialized = new EventEmitter();
        this.ready = new EventEmitter();
        this.message = new EventEmitter();
        this.closed = new EventEmitter();
        this.launchParams = {};
        this.cisrMonitor = null;
        this._iFrameId = 'launch_frame';
        this._unsubscribe$ = new Subject();
        this.rootElMessageHandler = (evt) => {
            console.log('integration-ngx heard message from elements root', evt);
            // This evt is actually a CustomEvent, just TS doesn't believe it.
            if (evt instanceof CustomEvent) {
                this.onToolRootMessage(evt.detail);
            }
            else {
                console.error('Incorrectly formatted message emitted from root element. Ignoring!', evt);
            }
        };
        // avoids Angular build error
        // https://stackoverflow.com/a/53715642
        this._document = this.document;
        this.iFrameOnLoadHandler = this.onIframeLoad.bind(this);
    }
    getResizerScrollingValue(iFrameScrollingAttr) {
        if (iFrameScrollingAttr === 'yes') {
            return true;
        }
        if (iFrameScrollingAttr === 'no') {
            return false;
        }
        if (iFrameScrollingAttr === 'auto') {
            return 'auto';
        }
        return 'omit';
    }
    ngOnDestroy() {
        this.destroyLtiLaunch();
        this.destroyNativeRootElementsLaunch();
        this.stopCisrMonitor();
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }
    ngOnInit() {
        if (!this.iFrameId && this._document) {
            // The index below is an attempt to provide a unique id by
            // querying the DOM for the number of iframes present.
            // It doesn't feel bullet-proof, since one might think
            // two components might make this query before their iframes
            // are attached. But, it has been observed that two launches
            // successfully occur within one template. So it feels 'good enough'.
            const index = this._document.getElementsByTagName('iframe').length;
            this._iFrameId = `launch_frame_${index}`;
        }
        else {
            // in case the above doesn't work, the platform can set it
            this._iFrameId = this.iFrameId || 'default_launch_frame_id';
        }
        // routed-launch parameters
        if (this.routeParams) {
            if (!this.route) {
                throw new Error('Launcher routeParams were specified, but no provider for ActivatedRoute exists! RouterModule is likely missing.');
            }
            this.outletName = `${this._iFrameId}-outlet`;
            this.routeRequest = Object.assign(Object.assign({}, this.routeParams), { outlet: this.outletName, activatedRoute: this.route });
        }
        // launchTarget and launchParameters must be set
        // before the view is initialized so the form is
        // properly configured for an <iframe> lti launch
        this.launchTarget = this.getLaunchTarget();
        this.launchParameters = this.getLaunchParameters();
    }
    /**
     * Launch the asset after the view was rendered
     */
    ngAfterViewInit() {
        this.launch();
    }
    getLaunchTarget() {
        return Boolean(this.newWindow) ? '_blank' : this._iFrameId;
    }
    getLaunchParameters() {
        return Object.keys(this.launchParams).reduce((allValues, key) => {
            const value = this.launchParams[key];
            if (value !== undefined) {
                allValues.push({ k: key, v: value });
            }
            return allValues;
        }, []);
    }
    launch() {
        if (this.elementsRootConfig) {
            // Special case where a platform knows it wants to
            // perform a native launch of an element registered
            // as 'root'.
            //
            // Currently, the only use case here is to pull in the labs
            // root component and configure it. But, this pattern could
            // potentially be used generically.
            this.elementLoaderService.loadElement('root', this.injector)
                .pipe(first())
                .subscribe((rootEl) => this.nativeRootElementsLaunch(rootEl));
        }
        else if (this.routeRequest) {
            // A route request means the platform wants to load a component natively.
            // Intended for internal use by labs to short-circuit the launch process.
            // See if we satisfy this route request via angular elements
            const elementId = this.routeRequest.moduleId;
            this.elementLoaderService.loadElement(elementId, this.injector)
                .pipe(first())
                .subscribe({
                next: (el) => {
                    // This element shouldn't have inputs our outputs,
                    // data shared with the root or app is expected
                    // to be communicated via services.
                    // So, we just need to append the element.
                    this.elementRef.nativeElement.append(el);
                },
                error: (err) => {
                    if (this.routeRequest) {
                        // This case might be intentionally or unintentionally
                        // handled, so let's tell someone why with a gentle warn.
                        console.warn(err);
                        console.log('Falling back to perform routed launch...');
                        // See if we satisfy this route request via routed launch
                        try {
                            this.moduleRouterService.routedLaunch(this.routeRequest);
                        }
                        catch (err) {
                            if (!this.routeRequest.disableLti) {
                                console.log('Falling back to perform LTI launch...');
                                this.ltiLaunch();
                            }
                        }
                    }
                }
            });
        }
        else {
            // we're going to do a plain ol' LTI launch
            this.ltiLaunch();
        }
    }
    nativeRootElementsLaunch(rootEl) {
        // clean up the previous launch
        this.destroyNativeRootElementsLaunch();
        this.stopCisrMonitor();
        // save a reference so we can destroy it later
        this.rootEl = rootEl;
        // pass in the config for the root
        rootEl.setAttribute('config', JSON.stringify(this.elementsRootConfig));
        // listen to any messages coming from the root
        rootEl.addEventListener('message', this.rootElMessageHandler);
        // listen for LTI messages
        this.listenToCisrLaunch();
        // render the element on the DOM
        this.elementRef.nativeElement.append(rootEl);
        // announce the root has initialized
        this.onToolRootInitialized();
        // forward tool commands when the tool is ready
        this.ready.pipe(mergeMap(() => this.toolCommand$ ? this.toolCommand$ : EMPTY), takeUntil(this._unsubscribe$))
            .subscribe((command) => {
            const message = this.buildMessage(command);
            // pass in the message as a serialized attribute
            rootEl.setAttribute('command', JSON.stringify(message));
        });
    }
    ltiLaunch() {
        // clean up the previous iframe launch
        this.destroyLtiLaunch();
        this.stopCisrMonitor();
        // Ensure the form exists
        if (this.formRef === undefined || !(this.formRef.nativeElement instanceof HTMLFormElement)) {
            throw new LauncherError('Launch requires a <form>, but none exists!');
        }
        if (!this.newWindow) {
            if (!this.iframe) {
                this.iframe = this.createIframeEl();
                this.renderer.insertBefore(this.elementRef.nativeElement, this.iframe, this.formRef.nativeElement);
            }
            // Ensure the iframe exists
            if (!(this.iframe instanceof HTMLIFrameElement)) {
                throw new LauncherError('Could not add an <iframe> as the launch target to the DOM.');
            }
        }
        this.formRef.nativeElement.submit();
        this.listenToCisrLaunch();
        // forward tool commands when the tool is ready
        this.ready.pipe(mergeMap(() => this.toolCommand$ ? this.toolCommand$ : EMPTY), takeUntil(this._unsubscribe$))
            .subscribe((command) => {
            const message = this.buildMessage(command);
            this.sendMessageToIFrame(message);
        });
    }
    listenToCisrLaunch() {
        // LaunchId is only defined for CISR launches
        if (this.launchId) {
            // Track the CISR using websocket connection to LARS
            this.larsClient.listenToCisrLaunch(this.launchId, {
                onSelection: (selection) => {
                    // send the info down to the platform
                    const message = {
                        subject: 'cisr',
                        body: selection,
                        timestamp: new Date(),
                        index: null,
                    };
                    this.message.next(message);
                    this.stopCisrMonitor();
                },
                onError: (type, event) => {
                    // send the info down to the platform
                    const message = {
                        subject: type,
                        body: event,
                        timestamp: new Date(),
                        index: null,
                    };
                    this.message.next(message);
                    this.stopCisrMonitor();
                },
            })
                .pipe(first())
                .subscribe((monitor) => this.cisrMonitor = monitor);
        }
    }
    onToolRootMessage(message) {
        // iframe messages are events outside Angular, so we need to
        // manually trigger Angular's change detection on each message
        // https://stackoverflow.com/questions/34827334/triggering-change-detection-manually-in-angular
        this.zone.run(() => {
            this.message.next(message);
            if (message.subject === 'tool_ready') {
                this.ready.next();
                this.ready.complete();
            }
            else if (message.subject === 'app_ready') {
                const hasTitle = this.iframe && this.iframe.getAttribute('title');
                if (this.iframe && !hasTitle && message.body && message.body.iFrameTitle) {
                    this.renderer.setAttribute(this.iframe, 'title', message.body.iFrameTitle);
                }
            }
            else if (message.subject === 'tool_done') {
                this.destroyLtiLaunch();
                this.destroyNativeRootElementsLaunch();
                this.closed.next();
                this.closed.complete();
            }
        });
    }
    onToolRootInitialized() {
        // manually trigger Angular's change detection on each message
        this.zone.run(() => {
            this.initialized.next();
            this.initialized.complete();
        });
    }
    createIframeEl() {
        // Here we create an <iframe> using Renderer2!
        // https://medium.com/@kmathy/angular-manipulate-properly-the-dom-with-renderer-16a756508cba
        //
        // Typically in Angular, we would put the <iframe> and name in the template
        // like this [name]="iFrameId" or name="{{iFrameId}}". However, this causes
        // the launch to appear in a new tab on every launch. This doesn't work.
        //
        // Angular's template cannot set the name property in such a way that the browser
        // recognizes it for the launch. The browser appears to grab the name when the
        // <iframe> is attached to the DOM, and Angular's templating sets the name attribute
        // a moment too late.
        //
        // So here we create the <iframe> all at once, then attach.
        const iframeEl = this.renderer.createElement('iframe');
        // Safari needs the id and name of the iframe to be the same values
        // otherwise it launches the iframe in a new window!
        // https://forums.macrumors.com/threads/safari-and-opening-target-links-in-frames.190288/#post-2272885
        this.renderer.setAttribute(iframeEl, 'id', this._iFrameId);
        this.renderer.setAttribute(iframeEl, 'name', this._iFrameId);
        if (this.styles && this.styles.iframe) {
            const iframeStyles = this.styles.iframe;
            Object.keys(iframeStyles).forEach((styleName) => {
                this.renderer.setStyle(iframeEl, styleName, iframeStyles[styleName]);
            });
        }
        const featurePolicy = this.getToolFeaturePolicy();
        this.renderer.setAttribute(iframeEl, 'allow', policyToString(featurePolicy));
        this.renderer.setAttribute(iframeEl, 'allowfullscreen', 'true');
        this.renderer.listen(iframeEl, 'load', this.iFrameOnLoadHandler);
        if (this.iFrameClass) {
            this.renderer.addClass(iframeEl, this.iFrameClass);
        }
        if (this.iFrameTitle) {
            this.renderer.setAttribute(iframeEl, 'title', this.iFrameTitle);
        }
        return iframeEl;
    }
    // This feature policy logic is temporary. The policy should be obtained from the LARS backend.
    // TODO: https://jira.mheducation.com/browse/DLECMP-3379
    getToolFeaturePolicy() {
        // NOTE: for some reason, including this allow="fullscreen", causes screenfull.enabled to return 'false'
        // screenfull JS is used in the LABS select component
        if (this.launchUrl && this.launchUrl.endsWith('mheducation.com/writing-tool/launch/')) {
            // enable microphone in iframe
            // https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-permissions-in-cross-origin-iframes
            return { microphone: this.launchUrl };
        }
    }
    /**
     * Properly clean up the iframe.
     * Namely, removing all listeners and the
     * element itself from the DOM.
     */
    destroyLtiLaunch() {
        if (this.iframe === undefined) {
            return;
        }
        if (!(this.iframe instanceof HTMLIFrameElement)) {
            return;
        }
        if (hasIframeResizer(this.iframe)) {
            this.iframe.iFrameResizer.removeListeners();
            this.iframe.iFrameResizer.close();
            delete this.iframe.iFrameResizer;
        }
    }
    /**
     * Properly clean up our root element.
     * Namely, removing all listeners and the
     * element itself from the DOM.
     */
    destroyNativeRootElementsLaunch() {
        if (!this.rootEl) {
            return;
        }
        this.rootEl.removeEventListener('message', this.rootElMessageHandler);
        this.elementRef.nativeElement.removeChild(this.rootEl);
        this.rootEl = undefined;
    }
    stopCisrMonitor() {
        if (this.cisrMonitor) {
            this.cisrMonitor.destroy();
            this.cisrMonitor = null;
        }
    }
    onIframeLoad() {
        if (this.iframe === undefined) {
            return;
        }
        if (!(this.iframe instanceof HTMLIFrameElement)) {
            return;
        }
        this.loaded.next();
        if (!hasIframeResizerInstalled(window)) {
            // the client is not using the resizer, so we need
            // to apply the scrolling attribute directly
            if (this.iFrameScrollingAttr) {
                this.renderer.setAttribute(this.iframe, 'scrolling', this.iFrameScrollingAttr);
            }
            return;
        }
        // Check if _this_ iframe has already been initialized
        if (hasIframeResizer(this.iframe)) {
            return;
        }
        const iframeCallbacks = {
            messageCallback: ({ message }) => this.onToolRootMessage(message),
            initCallback: () => this.onToolRootInitialized()
        };
        const iframeDefaultOptions = {
            checkOrigin: false,
            sizeWidth: true,
            tolerance: 10,
            warningTimeout: 0,
            scrolling: this.getResizerScrollingValue(this.iFrameScrollingAttr),
        };
        // iframeCallbacks go last, we do not want
        // to allow those to be overridden
        const iframeOptions = Object.assign(Object.assign(Object.assign({}, iframeDefaultOptions), this.iFrameResizerOptions), iframeCallbacks);
        window.iFrameResize(iframeOptions, this.iframe);
        if (!hasIframeResizer(this.iframe)) {
            console.error('Unable to attach iframe-resizer to iframe element');
            return;
        }
        console.log('iframe loaded!', this.iframe.iFrameResizer);
    }
    sendMessageToIFrame(messageParams) {
        if (!this.iframe) {
            throw new Error('Cannot send message to iframe, iframe is missing!');
        }
        if (!this.iframe.iFrameResizer) {
            throw new Error('Cannot send message to iframe, iframe.iFrameResizer is missing!');
        }
        this.iframe.iFrameResizer.sendMessage(messageParams);
    }
    buildMessage(command) {
        var _a, _b;
        if (!command.subject) {
            throw new Error('Cannot build Message, command must have a subject!');
        }
        const message = {
            body: command.body,
            index: (_a = command.index) !== null && _a !== void 0 ? _a : null,
            subject: command.subject,
            timestamp: (_b = command.timestamp) !== null && _b !== void 0 ? _b : new Date(),
        };
        return message;
    }
};
LauncherComponent.ɵfac = function LauncherComponent_Factory(t) { return new (t || LauncherComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(LarsClient), ɵngcc0.ɵɵdirectiveInject(ModuleRouterService), ɵngcc0.ɵɵdirectiveInject(ElementLoaderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ActivatedRoute, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
LauncherComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LauncherComponent, selectors: [["dle-integration-launcher"]], viewQuery: function LauncherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formRef = _t.first);
    } }, inputs: { launchParams: "launchParams", launchUrl: "launchUrl", launchId: "launchId", newWindow: "newWindow", iFrameClass: "iFrameClass", styles: "styles", iFrameScrollingAttr: "iFrameScrollingAttr", iFrameResizerOptions: "iFrameResizerOptions", iFrameId: "iFrameId", iFrameTitle: "iFrameTitle", toolCommand$: "toolCommand$", routeParams: "routeParams", elementsRootConfig: "elementsRootConfig" }, outputs: { loaded: "loaded", initialized: "initialized", ready: "ready", message: "message", closed: "closed" }, decls: 4, vars: 4, consts: [[3, "name", 4, "ngIf"], ["method", "post", 3, "target", "action"], ["launchForm", ""], ["type", "hidden", 3, "name", "value", 4, "ngFor", "ngForOf"], [3, "name"], ["type", "hidden", 3, "name", "value"]], template: function LauncherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LauncherComponent_named_outlet_0_Template, 1, 1, "named-outlet", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1, 2);
        ɵngcc0.ɵɵtemplate(3, LauncherComponent_input_3_Template, 1, 2, "input", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeParams);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("target", ctx.launchTarget)("action", ctx.launchUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.launchParameters);
    } }, dependencies: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, NamedOutletDirective]; }, encapsulation: 2 });
LauncherComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: LarsClient },
    { type: ModuleRouterService },
    { type: ElementLoaderService },
    { type: ActivatedRoute, decorators: [{ type: Optional }] },
    { type: Injector }
];
__decorate([
    Output(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "loaded", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "initialized", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "ready", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "message", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "closed", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "launchParams", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "launchUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "launchId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "newWindow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "iFrameClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "styles", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "iFrameScrollingAttr", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "iFrameResizerOptions", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "iFrameId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "iFrameTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "toolCommand$", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "routeParams", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "elementsRootConfig", void 0);
__decorate([
    ViewChild('launchForm'),
    __metadata("design:type", Object)
], LauncherComponent.prototype, "formRef", void 0);
LauncherComponent = __decorate([ __param(3, Inject(DOCUMENT)),
    __param(7, Optional()),
    __metadata("design:paramtypes", [ElementRef,
        NgZone,
        Renderer2, Object, LarsClient,
        ModuleRouterService,
        ElementLoaderService,
        ActivatedRoute,
        Injector])
], LauncherComponent);

// Taken from https://github.com/angular/angular/issues/17173#issuecomment-415322417
// Angular does not support dynamically naming router outlets.
// So this is a "shim" so we can dynamically name router outlets.
let NamedOutletDirective = class NamedOutletDirective {
    constructor(parentContexts, location, resolver, changeDetector) {
        this.parentContexts = parentContexts;
        this.location = location;
        this.resolver = resolver;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        if (!this.name) {
            throw new Error('named-outlet must have a name!');
        }
        this.outlet = new RouterOutlet(this.parentContexts, this.location, this.resolver, this.name, this.changeDetector);
        this.outlet.ngOnInit();
    }
    ngOnDestroy() {
        if (this.outlet) {
            this.outlet.ngOnDestroy();
        }
    }
};
NamedOutletDirective.ɵfac = function NamedOutletDirective_Factory(t) { return new (t || NamedOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ChildrenOutletContexts), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NamedOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NamedOutletDirective, selectors: [["named-outlet"]], inputs: { name: "name" }, exportAs: ["outlet"] });
NamedOutletDirective.ctorParameters = () => [
    { type: ChildrenOutletContexts },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver },
    { type: ChangeDetectorRef }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], NamedOutletDirective.prototype, "name", void 0);
NamedOutletDirective = __decorate([ __metadata("design:paramtypes", [ChildrenOutletContexts,
        ViewContainerRef,
        ComponentFactoryResolver,
        ChangeDetectorRef])
], NamedOutletDirective);

/** Distance in pixels that elements should be loaded before coming into view. */
const VIEWPORT_BUFFER = 400;
let LazyLoadService = class LazyLoadService {
    constructor() {
        /** Subject that's fired when an element is ready to be loaded. */
        this.loadSubject = new Subject();
        this.options = {
            rootMargin: `${VIEWPORT_BUFFER}px`,
        };
        this.intersectionObserver = this.createIntersectionObserver();
    }
    /**
     * Observes an element and returns an Observable that completes when it comes into view.
     */
    observe(element) {
        if (this.intersectionObserver) {
            this.intersectionObserver.observe(element);
        }
        return this.loadSubject.pipe(
        // Only fire when it matches the provided element
        filter((loadElement) => element === loadElement), 
        // The inner value doesn't matter after this point.
        map(() => undefined), 
        // Complete the Observable.
        take(1));
    }
    createIntersectionObserver() {
        if (hasIntersectionObserver(window)) {
            return new window.IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.loadSubject.next(entry.target);
                        this.unobserve(entry.target);
                    }
                });
            }, this.options);
        }
    }
    /**
     * Stop observing an element.
     */
    unobserve(element) {
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(element);
        }
    }
    ngOnDestroy() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
    }
};
LazyLoadService.ɵfac = function LazyLoadService_Factory(t) { return new (t || LazyLoadService)(); };
LazyLoadService.ɵprov = ɵɵdefineInjectable({ factory: function LazyLoadService_Factory() { return new LazyLoadService(); }, token: LazyLoadService, providedIn: "root" });

let LazyLoadDirective = class LazyLoadDirective {
    constructor(element, lazyLoadService) {
        this.element = element;
        this.lazyLoadService = lazyLoadService;
        /** Allow lazy loading to be conditionally turned off. */
        this.lazyLoad = true;
        /** Fires when the element should load. */
        this.load = new EventEmitter();
    }
    ngOnChanges() {
        if (this.lazyLoad) {
            this.lazyLoadSubscription = this.lazyLoadService
                .observe(this.element.nativeElement)
                .subscribe(() => {
                this.load.emit();
            });
        }
        else if (this.lazyLoadSubscription) {
            this.lazyLoadSubscription.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.lazyLoadService.unobserve(this.element.nativeElement);
        if (this.lazyLoadSubscription) {
            this.lazyLoadSubscription.unsubscribe();
        }
    }
};
LazyLoadDirective.ɵfac = function LazyLoadDirective_Factory(t) { return new (t || LazyLoadDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(LazyLoadService)); };
LazyLoadDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LazyLoadDirective, selectors: [["", "lazyLoad", ""]], inputs: { lazyLoad: "lazyLoad" }, outputs: { load: "load" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
LazyLoadDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: LazyLoadService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], LazyLoadDirective.prototype, "lazyLoad", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], LazyLoadDirective.prototype, "load", void 0);
LazyLoadDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        LazyLoadService])
], LazyLoadDirective);

var IntegrationLauncherModule_1;
let IntegrationLauncherModule = IntegrationLauncherModule_1 = class IntegrationLauncherModule {
    static withConfig(configFactoryOptions) {
        return {
            ngModule: IntegrationLauncherModule_1,
            providers: [
                {
                    provide: LAUNCHER_CONFIG,
                    useFactory: configFactoryOptions.useFactory,
                    deps: configFactoryOptions.deps
                },
                LarsClient,
                LauncherService,
                ModuleRouterService,
                ElementLoaderService
            ]
        };
    }
};
IntegrationLauncherModule.ɵfac = function IntegrationLauncherModule_Factory(t) { return new (t || IntegrationLauncherModule)(); };
IntegrationLauncherModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IntegrationLauncherModule });
IntegrationLauncherModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LarsClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.Observable, decorators: [{
                type: Inject,
                args: [LAUNCHER_CONFIG]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LauncherService, [{
        type: Injectable
    }], function () { return [{ type: LarsClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetLauncherComponent, [{
        type: Component,
        args: [{
                selector: 'dle-integration-asset-launcher',
                template: "<div [lazyLoad]=\"lazyLoad\" (load)=\"readyToLaunch.next()\">\n  <dle-integration-launcher\n    *ngIf=\"launchUrl !== undefined\"\n    [newWindow]=\"launchInNewWindow\"\n    [launchId]=\"launchId\"\n    [launchUrl]=\"launchUrl\"\n    [launchParams]=\"launchParams\"\n    [routeParams]=\"routeParams\"\n    [iFrameClass]=\"iFrameClass\"\n    [styles]=\"styles\"\n    [iFrameScrollingAttr]=\"iFrameScrollingAttr\"\n    [iFrameResizerOptions]=\"iFrameResizerOptions\"\n    [iFrameId]=\"iFrameId\"\n    [iFrameTitle]=\"iFrameTitle\"\n    [toolCommand$]=\"toolCommand$\"\n    [elementsRootConfig]=\"labsConfig\"\n    (loaded)=\"loaded.next()\"\n    (initialized)=\"initialized.next()\"\n    (ready)=\"ready.next()\"\n    (closed)=\"closed.next()\"\n    (message)=\"message.next($event)\"\n  ></dle-integration-launcher>\n</div>\n"
            }]
    }], function () { return [{ type: LauncherService }]; }, { loaded: [{
            type: Output
        }], initialized: [{
            type: Output
        }], ready: [{
            type: Output
        }], message: [{
            type: Output
        }], closed: [{
            type: Output
        }], launchRequested: [{
            type: Output
        }], lazyLoad: [{
            type: Input
        }], assetXid: [{
            type: Input
        }], options: [{
            type: Input
        }], launchInNewWindow: [{
            type: Input
        }], iFrameClass: [{
            type: Input
        }], styles: [{
            type: Input
        }], iFrameScrollingAttr: [{
            type: Input
        }], iFrameResizerOptions: [{
            type: Input
        }], iFrameId: [{
            type: Input
        }], iFrameTitle: [{
            type: Input
        }], toolCommand$: [{
            type: Input
        }], routeParams: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolLauncherComponent, [{
        type: Component,
        args: [{
                selector: 'dle-integration-tool-launcher',
                template: "<div [lazyLoad]=\"lazyLoad\" (load)=\"readyToLaunch.next()\">\n  <dle-integration-launcher\n    *ngIf=\"launchUrl !== undefined\"\n    [newWindow]=\"launchInNewWindow\"\n    [launchId]=\"launchId\"\n    [launchUrl]=\"launchUrl\"\n    [launchParams]=\"launchParams\"\n    [routeParams]=\"routeParams\"\n    [iFrameClass]=\"iFrameClass\"\n    [styles]=\"styles\"\n    [iFrameScrollingAttr]=\"iFrameScrollingAttr\"\n    [iFrameResizerOptions]=\"iFrameResizerOptions\"\n    [iFrameId]=\"iFrameId\"\n    [iFrameTitle]=\"iFrameTitle\"\n    [toolCommand$]=\"toolCommand$\"\n    [elementsRootConfig]=\"labsConfig\"\n    (loaded)=\"loaded.next()\"\n    (initialized)=\"initialized.next()\"\n    (ready)=\"ready.next()\"\n    (closed)=\"closed.next()\"\n    (message)=\"message.next($event)\"\n  ></dle-integration-launcher>\n</div>\n"
            }]
    }], function () { return [{ type: LauncherService }]; }, { loaded: [{
            type: Output
        }], initialized: [{
            type: Output
        }], ready: [{
            type: Output
        }], message: [{
            type: Output
        }], closed: [{
            type: Output
        }], launchRequested: [{
            type: Output
        }], lazyLoad: [{
            type: Input
        }], toolXid: [{
            type: Input
        }], options: [{
            type: Input
        }], launchInNewWindow: [{
            type: Input
        }], iFrameClass: [{
            type: Input
        }], styles: [{
            type: Input
        }], iFrameScrollingAttr: [{
            type: Input
        }], iFrameResizerOptions: [{
            type: Input
        }], iFrameId: [{
            type: Input
        }], iFrameTitle: [{
            type: Input
        }], toolCommand$: [{
            type: Input
        }], routeParams: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModuleRouterService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.Router, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ElementLoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.Observable, decorators: [{
                type: Inject,
                args: [LAUNCHER_CONFIG]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LauncherComponent, [{
        type: Component,
        args: [{
                selector: 'dle-integration-launcher',
                template: "\n<named-outlet *ngIf=\"routeParams\" [name]=\"outletName\"></named-outlet>\n\n<!-- <iframe> added dynamically with Renderer2 -->\n<form\n  #launchForm\n  [target]=\"launchTarget\"\n  [action]=\"launchUrl\"\n  method=\"post\"\n>\n    <input\n      *ngFor=\"let param of launchParameters\"\n      [name]=\"param.k\"\n      [value]=\"param.v\"\n      type=\"hidden\"\n    />\n</form>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: LarsClient }, { type: ModuleRouterService }, { type: ElementLoaderService }, { type: ɵngcc4.ActivatedRoute, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.Injector }]; }, { loaded: [{
            type: Output
        }], initialized: [{
            type: Output
        }], ready: [{
            type: Output
        }], message: [{
            type: Output
        }], closed: [{
            type: Output
        }], launchParams: [{
            type: Input
        }], launchUrl: [{
            type: Input
        }], launchId: [{
            type: Input
        }], newWindow: [{
            type: Input
        }], iFrameClass: [{
            type: Input
        }], styles: [{
            type: Input
        }], iFrameScrollingAttr: [{
            type: Input
        }], iFrameResizerOptions: [{
            type: Input
        }], iFrameId: [{
            type: Input
        }], iFrameTitle: [{
            type: Input
        }], toolCommand$: [{
            type: Input
        }], routeParams: [{
            type: Input
        }], elementsRootConfig: [{
            type: Input
        }], formRef: [{
            type: ViewChild,
            args: ['launchForm']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NamedOutletDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'named-outlet',
                exportAs: 'outlet'
            }]
    }], function () { return [{ type: ɵngcc4.ChildrenOutletContexts }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ChangeDetectorRef }]; }, { name: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyLoadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyLoadDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[lazyLoad]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: LazyLoadService }]; }, { lazyLoad: [{
            type: Input
        }], load: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IntegrationLauncherModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AssetLauncherComponent,
                    ToolLauncherComponent,
                    LauncherComponent,
                    NamedOutletDirective,
                    LazyLoadDirective,
                ],
                exports: [
                    AssetLauncherComponent,
                    ToolLauncherComponent,
                    NamedOutletDirective,
                    LazyLoadDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IntegrationLauncherModule, { declarations: function () { return [AssetLauncherComponent, ToolLauncherComponent, LauncherComponent, NamedOutletDirective, LazyLoadDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AssetLauncherComponent, ToolLauncherComponent, NamedOutletDirective, LazyLoadDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AssetLauncherComponent, IntegrationLauncherModule, LAUNCHER_CONFIG, LazyLoadDirective, NamedOutletDirective, ToolLauncherComponent, defaultFeaturePolicy, hasIframeResizer, hasIframeResizerInstalled, hasIntersectionObserver, policyToString, LauncherService as ɵa, LarsClient as ɵb, LauncherComponent as ɵc, ModuleRouterService as ɵd, ElementLoaderService as ɵe, LazyLoadService as ɵf };

